class AnnouncementRotator extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    if (this.slides.length < 2) return;

    this.index = Math.max(
      this.slides.findIndex((slide) => slide.hasAttribute('data-active')),
      0
    );

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-direction]');
      if (!button) return;
      this.show(this.index + (button.dataset.direction === 'next' ? 1 : -1));
      this.startAutoplay();
    });

    this.startAutoplay();

    if (Shopify.designMode) {
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.indexOf(event.target);
        if (index >= 0) {
          this.stopAutoplay();
          this.show(index);
        }
      });
    }
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  show(index) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => {
      const active = i === this.index;
      slide.toggleAttribute('data-active', active);
      // inert, not just aria-hidden: hidden slides' links must leave the tab order too.
      slide.inert = !active;
      if (active) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    const seconds = parseInt(this.dataset.autoplay, 10);
    if (!seconds) return;
    this.timer = setInterval(() => this.show(this.index + 1), seconds * 1000);
  }

  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
  }
}
customElements.define('announcement-rotator', AnnouncementRotator);
